function chunk(arr, size) {
    return Array.from({
        length: Math.ceil(arr.length / size),
    }, (v, i) => arr.slice(i * size, i * size + size));
}
function is2DArray(arr) {
    return Array.isArray(arr[0]);
}
function groupBy(arr, indicator, defaultGroup = 'default') {
    return arr
        .map(val => val[indicator])
        .reduce((acc, val, i) => {
        const group = val !== null && val !== void 0 ? val : defaultGroup;
        acc[group] = (acc[group] || []).concat(arr[i]);
        return acc;
    }, {});
}

export { chunk, groupBy, is2DArray };
//# sourceMappingURL=array-utils.js.map
